import presetListView from './PresetListView'
const presetSelect = {
  hasBuilderButton: true,
  hasNormsTab: true,
  presetListView
}

export default presetSelect
export { presetSelect }
